import { render, staticRenderFns } from "./Frase.vue?vue&type=template&id=b4a05c2e"
import script from "./Frase.vue?vue&type=script&lang=js"
export * from "./Frase.vue?vue&type=script&lang=js"
import style0 from "./Frase.vue?vue&type=style&index=0&id=b4a05c2e&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports